/**
 *
 * "Define deckmodes"
 *
 * @file   deckMode.js
 * @author Lateral
 * @since  2023
 */
export const DeckMode = {
  /**
   * @constant
   *  Define deckmodes in String
   */
  default: 'default',
  edit: 'edit',
  maintenance: 'maintenance',
  heatMap: 'heatmap',
  //treat these as sub-modes of maintenance. We can use `string.includes(DeckMode.maintenance)` to include these.
  preMaintenance: 'pre-maintenance',
  postMaintenance: 'post-maintenance'
}
